import React from "react";

// Skeleton placeholder for the Coach "Dashboard" (overview) tab while data loads.
// Mirrors the real layout: filter bar + weekly heatmap + student score cards grid.
export default function OverviewSkeleton({ cards = 6 }) {
	return (
		<div className="overview-skeleton" aria-busy="true" aria-label="Chargement du tableau de bord">
			{/* Filter bar */}
			<div className="ovs-filterbar">
				<span className="skeleton skeleton-line" style={{ width: 180 }} />
				<span className="skeleton skeleton-line" style={{ width: 120, marginLeft: "auto" }} />
			</div>

			{/* Weekly heatmap */}
			<div className="overview-heatmap">
				<div className="ovs-heatmap-title skeleton skeleton-line" style={{ width: 220, margin: "0 auto 14px" }} />
				<div className="ovs-heatmap-row">
					{Array.from({ length: 7 }).map((_, i) => (
						<div key={i} className="ovs-heatmap-col">
							<span className="skeleton skeleton-line sm" style={{ width: 28 }} />
							<span className="skeleton skeleton-line sm" style={{ width: 18 }} />
							<span className="skeleton skeleton-bar" style={{ height: `${30 + ((i * 37) % 60)}%` }} />
						</div>
					))}
				</div>
			</div>

			{/* Scores section */}
			<div className="scores-section">
				<div className="ovs-scores-header">
					<span className="skeleton skeleton-line" style={{ width: 160, height: 20 }} />
					<span className="skeleton skeleton-line" style={{ width: 260 }} />
				</div>
				<div className="student-cards-grid">
					{Array.from({ length: cards }).map((_, i) => (
						<div key={i} className="student-card ovs-card">
							<div className="ovs-card-header">
								<span className="skeleton skeleton-circle" />
								<div className="ovs-card-identity">
									<span className="skeleton skeleton-line" style={{ width: "70%" }} />
									<span className="skeleton skeleton-line sm" style={{ width: "45%" }} />
								</div>
							</div>
							<span className="skeleton skeleton-line sm" style={{ width: "55%" }} />
							<span className="skeleton skeleton-pill" style={{ width: 90 }} />
							<div className="ovs-card-spark">
								<span className="skeleton skeleton-line sm" style={{ width: "40%", marginBottom: 6 }} />
								<div className="ovs-spark-bars">
									{Array.from({ length: 13 }).map((__, j) => (
										<span key={j} className="skeleton skeleton-spark" style={{ height: `${20 + ((j * 53 + i * 17) % 80)}%` }} />
									))}
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
